import req from "../http";

const scs = {
  // 同步 飛騰 人事資料
  syncPersonalInformation(params) {
    return req("post", "/SCS/PersonInfoImportToSCSByMatchId", params);
  },
};

export default scs;